export const BUTTON_PAY_ORDER = 'BUTTON_PAY_ORDER';
export const BUTTON_PAY_ANTI = 'BUTTON_PAY_ANTI';
export const BUTTON_PAY_ANTI_ERROR = 'BUTTON_PAY_ANTI_ERROR';
export const BUTTON_PAY_CHECK_ID_SUCCESS = 'BUTTON_PAY_CHECK_ID_SUCCESS';
export const BUTTON_PAY_PAY_SUCCESS = 'BUTTON_PAY_PAY_SUCCESS';
